import { Loader2, MessageSquare } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface SessionLoadingStateProps {
  message?: string;
}

export function SessionLoadingState({ message = 'Loading session...' }: SessionLoadingStateProps) {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center justify-center p-8 text-center">
          <div className="relative mb-4">
            <MessageSquare className="h-12 w-12 text-muted-foreground" />
            <Loader2 className="absolute -bottom-1 -right-1 h-6 w-6 animate-spin text-primary" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Loading Session</h3>
          <p className="text-sm text-muted-foreground">{message}</p>
        </CardContent>
      </Card>
    </div>
  );
}

export function SessionErrorState({ 
  error, 
  onRetry 
}: { 
  error: string; 
  onRetry?: () => void; 
}) {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center justify-center p-8 text-center">
          <MessageSquare className="h-12 w-12 text-destructive mb-4" />
          <h3 className="text-lg font-semibold mb-2 text-destructive">
            Session Error
          </h3>
          <p className="text-sm text-muted-foreground mb-4">{error}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="text-sm text-primary hover:underline"
            >
              Try again
            </button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}